import { DataRef, DragOverlay, useDndContext } from "@dnd-kit/core";
import { EuiFlexGroup, EuiText } from "@inscopix/ideas-eui";
import { DEFAULT_FOLDER_COLOR } from "./ProjectTablesTable.helpers";
import { ProjectTablesDraggableData } from "./ProjectTablesDndProvider";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { css } from "@emotion/react";
import { TableIcon } from "./TableIcon";

export const ProjectTablesDragOverlay = () => {
  const { active, activeNode } = useDndContext();
  const data = active?.data as DataRef<ProjectTablesDraggableData> | undefined;
  const table = useDataTableContext((s) =>
    s.tables.find((table) => table.id === data?.current?.tableId),
  );

  if (table === undefined) {
    return null;
  }

  return (
    <DragOverlay
      style={{
        cursor: "grabbing",
        backgroundColor: "white",
        padding: 5,
        border: "2px solid lightgray ",
        borderRadius: 5,
        width: activeNode?.offsetWidth,
        height: activeNode?.offsetHeight,
      }}
    >
      <EuiFlexGroup alignItems="center" justifyContent="center" gutterSize="xs">
        <TableIcon tableType={table.kind} />{" "}
        <EuiText>
          <span
            css={css`
              color: ${DEFAULT_FOLDER_COLOR} !important;
            `}
          >
            {table.name}{" "}
          </span>
          <span
            css={css`
              color: #ccc !important;
            `}
          >
            ({table.key})
          </span>
        </EuiText>
      </EuiFlexGroup>
    </DragOverlay>
  );
};
